<template>
    <div class="rooms-header">
        <div class="header-tabs">
            <div class="tabs" style="margin-left:12px">
                <div style="text-align:center;margin-top:54px"><span style="font-size:20px">SDK包</span></div>
                <div style="display:flex;justify-content: center;margin-top:36px">
                    <div class="beijing2" @mousemove="getsg()" @mouseleave="getgss()" @click="getxia()">
                        <div style="text-align:center">
                            <img src="@/assets/image/hongmeng.png" alt="" style="width:100px;" class="imgs" v-if="ind ==0">
                            <img src="@/assets/image/xiaz.png" alt="" style="width:100px;" class="imgs" v-else-if="ind ==1">
                        </div>
                        <p style="margin-top:64px"><span style="font-size:19px;color:#fff">鸿蒙SDK包</span></p>
                    </div>
                </div>
            </div>
            <div style="width: 399px;height: 588px;background: #FFFFFF;border-radius: 20px;position: relative;left: -12px; box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);">
                <div style="text-align: left;padding-left: 50px;margin-top:54px;"><span style="font-size: 20px;">红衫会议SDK</span></div>
                <div style="text-align: left;padding-left: 50px;height: 39px;font-size: 14px;color: #5B5B5B;margin-top:20px;">
					<span style="width: 299px;display:inline-block">红杉会议SDK，包含视频、语音、文字、共享白板与屏幕等各类视频会议常用功能。为各行各业伙伴提供简单轻松的SDK集成包，可通过单一接口实现入会，轻松集成于各种App中。</span>
				</div>
                <div style="text-align: left;padding-left: 50px;margin-top:54px;"><span style="font-size: 20px;">鸿蒙版</span></div>
                <div style="text-align: left;padding-left: 50px;height: 39px;font-size: 14px;color: #5B5B5B;margin-top:20px;">
					<span style="width: 299px;display:inline-block">
						sdk名称：红杉会议SDK<br/>
						sdk包名：hsmeeting_hmos_sdk<br/>
						最新版本号：1.0.6<br/>
						开发者：杭州红杉云澎信息技术有限公司<br/>
						MD5值：f28b9f5fa99f98971580b7be311ee78d<br/>
						个人信息处理规则：<a target="_blank" download="个人信息处理规则.pdf" href="个人信息处理规则.pdf">点击链接</a><br/>
						合规使用说明：<a target="_blank" download="合规使用说明.pdf" href="合规使用说明.pdf">点击链接</a><br/>
						隐私政策：<a target="_blank" download="隐私政策.pdf" href="隐私政策.pdf">点击链接</a>
					</span>
				</div>
            </div>
        </div>
        <div class="kehu">
            <span style="font-size: 16px;color: #5B5B5B;text-align:center;display:inline-block;width:100%;margin-top:60px">SDK使用引导</span>
            <div style="display: flex;justify-content: space-around;">
              <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/yi.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">下载SDK</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/hm1.png" alt="" style="">
                </div>
                <div style="margin-left:36px;margin-top:33px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>在本页面下载SDK包</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>联系我们获取SDK测试环境</p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/er.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">集成到应用中</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/hm2.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:33px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>集成到您的应用中</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>验证使用</p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/san.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">开始会议</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/kaihui.png" alt="" style="margin-top: -6px;width: 350px;height: 202px;">
                </div>
                <div style="margin-left:36px;margin-top:26px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>Rooms 支持发起会议和加入会议，并与其他客户端音视频互动</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;margin-top:15px"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>PC或手机端可以一键投屏Rooms，实时共享内容</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ind:0,
            ind1:0,
        }
    },
    methods:{
        getsg(){
             this.ind = 1
        },
        getgss(){
             this.ind = 0
        },
         getsg1(){
             this.ind1 = 1
        },
        getgss1(){
             this.ind1 = 0
        },
        getxia(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
			a.target="_blank"
            a.href = 'https://ohpm.openharmony.cn/#/cn/detail/hsmeeting_hmos_sdk'
            a.click()
            window.URL.revokeObjectURL(url)
        }
    }
}
</script>
<style lang="scss">

    .rooms-header{
        width: 1240px;
        margin: 0 auto;
        position: relative;
        top:300px;
        .header-tabs{
          
            display: flex;
           
            justify-content: space-between;
              
            .tabs{
               width: 752px;
               height: 588px;
               background: url('../../assets/image/beitu3.png');
               box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);
               border-radius: 20px;
               .beijing2{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                   cursor: pointer;
                   
               }
               .beijing3{
                   width: 304px;
                   height: 386px;
                   background: url('../../assets/image/beijing2.png');
                   text-align: center;
                   display: flex;
                   flex-direction: column;
                   justify-content: center;
                cursor: pointer;
               }
            }
        }
        .kehu{
            .ktabs{
                width: 386px;
                height: 447px;
                background: #FFFFFF;
                border: 1px solid #CAD9FF;
                border-radius: 10px;
                margin-top: 20px;
            }
        }
    }
    
</style>